<template>
    <template v-if="headCell?.title">
        <div
            class="a-table__head-mobile-field a-table__head-mobile-title"
            v-html="headCell.title"
        />
    </template>
    <template v-else>
        <div
            v-if="headCell?.val"
            class="a-table__head-mobile-field a-table__head-mobile-text"
            v-html="headCell.val"
        />
        <div
            v-if="headCell?.desc"
            class="a-table__head-mobile-field a-table__head-mobile-desc"
            v-html="headCell.desc"
        />
        <div
            v-if="headCell?.label"
            class="a-table__head-mobile-field a-table__head-mobile-label"
            v-html="headCell.label"
        />
        <div
            v-if="headCell?.product"
            class="a-table__head-mobile-field a-table__head-mobile-product"
            v-html="headCell.product"
        />
    </template>
</template>

<script setup>
defineOptions({
    name: 'STableMobileHeadCell',
});

defineProps({
    headCell: {
        type: Object,
        default: null,
    },
});
</script>

<style lang="postcss" scoped>
.a-table__head-mobile-field {
    margin-bottom: 16px;
}

.a-table__head-mobile-text {
    @mixin paragraph;

    font-weight: 700;
    color: var(--av-nav-primary);
}

.a-table__head-mobile-desc {
    color: var(--av-nav-primary);
}

.a-table__head-mobile-title {
    @mixin hero-subtle;
    color: var(--av-nav-primary);
}

.a-table__head-mobile-label {
    @mixin body;

    color: var(--av-fixed-success);
    margin-bottom: 4px;
}

.a-table__head-mobile-product {
    font-size: 24px;
    line-height: 24px;
    font-weight: bold;
}
</style>
